import {Tooltip} from '@mui/material'
import {Box, Loading, Skeleton, Typography} from '@viptech/react-components'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import TrendingIcon from 'src/images/TrendingIcon'

type DashboardCountCardProps = {
  title: string
  value: number | undefined | string
  loading: boolean
  description: string
  icon: React.ReactNode
  refetching?: boolean
  moreInfos: MoreInfoType[]
  rangeInfos: RangeInfos
  filteringRangeOfDates: boolean
}

type MoreInfoType = {
  label: string
  value: number | string
  percentage: number
  trendingUp: boolean
}

type RangeInfos = {
  rangeValue: number | string
  rangeDates: string
  percentage: number
  trendingUp: boolean
  average: number
}

function CountCardMoreInfos({title, value, description, loading, refetching, icon, moreInfos, filteringRangeOfDates, rangeInfos}: DashboardCountCardProps) {
  const {styledTheme} = usePersonalizedThemeByCompany()

  return (
    <Box position='relative' backgroundColor='white' borderRadius='16px' width='100%' style={{boxShadow: '0px 5px 8px 2px #00000026'}}>
      <Box display='flex' justifyContent='space-between' padding='24px 32px'>
        <Box display='flex' direction='column' rowGap='6px'>
          {icon}
          <Typography variant='label' size='16px' marginTop='8px' color='#55565B' weight={600} children={title} />

          {refetching && !loading && (
            <Tooltip title='Buscando atualizações' placement='top'>
              <Box position='absolute' right='24px' display='flex' columnGap='8px'>
                <Loading size='20px' />
              </Box>
            </Tooltip>
          )}

          {loading ? (
            <Box display='flex' direction='row' columnGap='8px' align='flex-end' marginTop='4px'>
              <Skeleton width={'72px'} height={'44px'} borderRadius='8px' />
              <Skeleton width={'50px'} height={'16px'} borderRadius='4px' />
            </Box>
          ) : (
            <Box display='flex' direction='row' columnGap='8px' align='flex-end'>
              <Tooltip title={value !== undefined ? value + ' registros' : undefined} placement='top'>
                <Typography variant='label' size='48px' lineHeight='48px' weight={700} color='#344054'>
                  {value !== undefined ? value : '-'}
                </Typography>
              </Tooltip>
              {value !== undefined && <Typography variant='label' size='14px' color='#55565B' children={description} />}
            </Box>
          )}
        </Box>

        <Box display='flex' direction='column' rowGap='5px' align='flex-end'>
          {!refetching &&
            !filteringRangeOfDates &&
            moreInfos.map((infos) => {
              return (
                <Box width='100%' display='flex' align='center' columnGap='15px' justifyContent='flex-end'>
                  <Typography
                    variant='p'
                    size='12px'
                    color='#55565B'
                    children={infos.label}
                    style={{display: 'flex', width: '100%', justifyContent: 'flex-start'}}
                  />

                  <Typography variant='label' size='20px' color='#344054' weight={600} children={infos.value} />

                  <Box
                    borderRadius='8px'
                    backgroundColor={infos.trendingUp ? styledTheme.icons.trendingIcon.upBackgroungColor : styledTheme.icons.trendingIcon.downBackgroundColor}
                    padding='4px 10px'
                    display='flex'
                    align='center'
                    justifyContent='space-between'
                    columnGap='10px'
                    minWidth='65px'>
                    <TrendingIcon trendingUp={infos.trendingUp} />
                    <Typography
                      variant='label'
                      size='14px'
                      weight={700}
                      color={infos.trendingUp ? styledTheme.icons.trendingIcon.upTextColor : styledTheme.icons.trendingIcon.downTextColor}>
                      {infos.percentage.toFixed(0)}%
                    </Typography>
                  </Box>
                </Box>
              )
            })}

          {!refetching && !loading && filteringRangeOfDates && (
            <Box display='flex' direction='column' justifyContent='space-between' height='100%'>
              <Box width='100%' display='flex' align='center' columnGap='15px' justifyContent='flex-end'>
                <Typography
                  variant='p'
                  size='12px'
                  color='#55565B'
                  children={rangeInfos.rangeDates}
                  style={{display: 'flex', width: '100%', justifyContent: 'flex-start'}}
                />
                <Typography variant='label' size='20px' color='#344054' weight={600} children={rangeInfos.rangeValue} />
                <Box
                  borderRadius='8px'
                  backgroundColor={
                    rangeInfos.trendingUp ? styledTheme.icons.trendingIcon.upBackgroungColor : styledTheme.icons.trendingIcon.downBackgroundColor
                  }
                  padding='4px 10px'
                  display='flex'
                  align='center'
                  justifyContent='space-between'
                  columnGap='10px'
                  minWidth='65px'>
                  <TrendingIcon trendingUp={rangeInfos.trendingUp} />
                  <Typography
                    variant='label'
                    size='14px'
                    weight={700}
                    color={rangeInfos.trendingUp ? styledTheme.icons.trendingIcon.upTextColor : styledTheme.icons.trendingIcon.downTextColor}>
                    {rangeInfos.percentage}%
                  </Typography>
                </Box>
              </Box>

              <Box alignSelf='flex-end'>
                <Typography
                  variant='p'
                  size='14px'
                  color='#55565B'
                  children={'Média de'}
                  style={{display: 'flex', width: '100%', justifyContent: 'flex-start', fontStyle: 'italic'}}
                />

                <Typography variant='label' size='48px' lineHeight='48px' weight={700} color='#344054' children={rangeInfos.average} />
                <Typography variant='label' size='16px' color='#55565B' children={'/dia'} marginLeft='5px' />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default CountCardMoreInfos
